import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { LoadingService } from '@core/shared';
import { Pagination } from '@core/shared/models/pagination';
import { CashrewardsService } from '../services/cashrewards.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PopUpModalComponent } from '@app/core/shared/components/popup-modal/popup-modal.component';

@UntilDestroy()
@Component({
  selector: 'app-cashrewards-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss']
})
export class CashRewardsTransactionsComponent implements OnInit {
  transactions: any[] = [];
  paginationDetails: Pagination = new Pagination();
  isWebInMobileView = false;

  constructor(public loadingService: LoadingService, private cashRewardsService: CashrewardsService,private modalService: NgbModal) {
    this.isWebInMobileView = !!(localStorage.getItem('token') && JSON.parse(localStorage.getItem('token')).hideHeaderFooter);
  }

  ngOnInit(): void {
    this.fetchTransactions();
  }
  

  onChange(pagination: Pagination) {
    this.paginationDetails = pagination;
    this.fetchTransactions();
  }

  private fetchTransactions() {
    const page = this.paginationDetails?.pageNumber || 1;
    const perPage = this.paginationDetails?.itemsPerPage || 10;
    this.loadingService
      .doLoading(this.cashRewardsService.getWalletTransactions({ page, perPage }), this)
      .pipe(untilDestroyed(this))
      .subscribe((res: any) => {
        this.transactions = res?.transactions || [];
        // Prefer totalRecords when provided; fallback to pages * perPage
        const total = typeof res?.totalRecords === 'number' ? res.totalRecords : (res?.totalPages || 0) * (res?.perPage || perPage);
        this.paginationDetails.totalNumberOfItems = total || 0;
        this.paginationDetails.itemsPerPage = perPage;
        this.paginationDetails.pageNumber = page;
      });
  }
}
